<template>
  <woot-modal
    :show="showAccountModal"
    :on-close="() => $emit('close-account-modal')"
  >
    <woot-modal-header
      :header-title="$t('SIDEBAR_ITEMS.CHANGE_ACCOUNTS')"
      :header-content="$t('SIDEBAR_ITEMS.SELECTOR_SUBTITLE')"
    />
    <div class="modal-body pb-2 flex flex-col gap-1">
      <div
        v-for="account in currentUser.accounts"
        :id="`account-${account.id}`"
        :key="account.id"
        class="pt-0 pb-0"
      >
        <button
          class="flex justify-between items-center px-4 py-3 w-full rounded transition-colors duration-200 cursor-pointer"
          @click="onChangeAccount(account.id)"
          :class="account.id === accountId ? 'bg-woot-50 text-woot-600 dark:bg-woot-700 dark:text-woot-50' : 'hover:bg-gray-100 text-gray-700 hover:dark:bg-gray-700 dark:text-gray-200'"
        >
          <div class="w-full text-left rtl:text-right">
              <div class="text-lg">
                {{ account.name }}
              </div>
              <div class="text-xs opacity-60">
                {{ account.role }}
              </div>
          </div>
          <fluent-icon
            v-show="account.id === accountId"
            class="text-woot-500 dark:text-gray-100"
            icon="checkmark-circle"
            type="solid"
            size="24"
          />
        </button>
      </div>
    </div>

    <div
      v-if="globalConfig.createNewAccountFromDashboard"
      class="flex justify-end items-center px-8 pb-8 pt-4 gap-2"
    >
      <button
        class="button success large w-full"
        @click="$emit('show-create-account-modal')"
      >
        {{ $t('CREATE_ACCOUNT.NEW_ACCOUNT') }}
      </button>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    showAccountModal: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
      globalConfig: 'globalConfig/get',
    }),
  },
  methods: {
    onChangeAccount(accountId) {
      const accountUrl = `/app/accounts/${accountId}/dashboard`;
      window.location.href = accountUrl;
    },
  },
};
</script>
